import * as React from 'react';
import { FC, useEffect, useMemo, useState } from 'react';
import { OCard } from '../../molecules';
import { useAppDispatch } from '../../../state';
import { Button } from 'primereact/button';
import { useAuth } from 'react-oidc-context';
import { addGenericRequest, AdditionalDetails, findGenericRequestsByStatus, GenericRequest, genericRequestSelector, GenericRequestStatus, issueCredential } from '../../../state/slices/genericrequest';
import { useSelector } from 'react-redux';
import { FilterService } from 'primereact/api';
import QRCode from 'react-qr-code';

const USER_REQUEST = 'userRequest';


export const WaardeOverdracht: FC = () => {
    const dispatch = useAppDispatch();
    let auth = useAuth();
    const [oidcUrl, setOidcUrl] = useState<string | undefined>()


    const genericRequestState = useSelector(genericRequestSelector);
    useEffect(() => {
        dispatch(findGenericRequestsByStatus({jwtToken: auth.user?.access_token!, status: GenericRequestStatus.INITIAL})).then((response) => {
            if (response.type.includes('fulfilled')) {
                if (response.payload.length === 0) {
                    const generateRandomNumber = (length: number) => {
                        return Math.floor(Math.random() * Math.pow(10, length));
                    };

                    let waardeBeleggingen = 180196.21;
                    let additionalDetails = {
                        familyName: auth.user?.profile?.family_name,
                        given_name: auth.user?.profile?.given_name,
                        dateOfBirth: auth.user?.profile?.birthdate,
                        polisNummer: generateRandomNumber(8).toString(),
                        waardeBeleggingen: waardeBeleggingen,
                        verwachtePensioenuitkeringPerJaar: waardeBeleggingen / 5,
                    } as AdditionalDetails;
                    dispatch(addGenericRequest({jwtToken: auth.user?.access_token!, additionalDetails: additionalDetails, requestType: 'waardeoverdracht', walletUrl: ''}));
                }
            }
        });
    }, [auth.user?.access_token]);

    function handleIssueCredential() {
        if (genericRequestState.singleItem?.frontendCorrelationKey !== undefined) {
            dispatch(issueCredential({jwtToken: auth.user?.access_token, correlationId: genericRequestState.singleItem?.frontendCorrelationKey, credentialIssuerTemplateKey: 'WaardeOverdracht'})).then((response) => {
                if (response.type.includes('fulfilled')) {
                    setOidcUrl(response.payload);
                }
            });
        }
    }

    function numberOfApprovedStillToApprove(genericRequest: GenericRequest | undefined): number {
        if (genericRequest === undefined) {
            return -1;
        }
        return genericRequest?.approvers?.filter(a => !a.approved).length!;
    }

    const walletUrl = useMemo(() => {
        const iPos1 = oidcUrl?.indexOf("?")
        return (window.location.hostname === 'localhost')
            ? oidcUrl?.replaceAll(oidcUrl.substring(0, iPos1), "http://localhost:3002")
            : oidcUrl?.replaceAll(oidcUrl.substring(0, iPos1), "https://wallet.acc.credenco.com");

    }, [oidcUrl]);
    return (
        <div className="container mx-auto px-4 mb-8">
            <div>
                <h1 className="text-3xl mt-16 mb-8">Waardeoverdracht</h1>
                {/*<p className="mb-4">In just a few steps you can apply for a company bank account.</p>*/}
            </div>

            <div className="">
                <OCard className="pt-5 mb-2 pb-6">
                    <div className="flex align-items-center mb-5">
                        <div className="">
                            <h2 className="text-xl xl:text-2xl">Start de waardeoverdracht naar een andere pensioenuitvoerder</h2>
                        </div>
                    </div>
                    <>
                        <p>Sla de waardeoverdracht credential op in uw wallet en stuur deze vervolgens naar de pensioenuitvoerder.
                        </p>

                        <button className="place-self-end text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded transition duration-300 w-max" onClick={event => handleIssueCredential()}>Save in my Wallet</button>
                        {(oidcUrl !== undefined) && (
                            <div style={{height: "auto", margin: "0 auto", maxWidth: 200, width: "100%"}}>
                                <a href={walletUrl} target="_blank">
                                <QRCode
                                    size={256}
                                    style={{height: "auto", maxWidth: "100%", width: "100%"}}
                                    value={oidcUrl ? oidcUrl : 'oidc://'}
                                    viewBox={`0 0 256 256`}
                                />
                                </a>
                            </div>

                        )}
                    </>
                </OCard>
            </div>
        </div>
    )
        ;
}
